<template>
    <div v-if="row">
        <span v-if="hasSample" @click="deleteSample">
            <i class="fal fa-check-square text-success fa-2x pointer" />
        </span>
        <span v-else @click="addSample">
            <i class="fal fa-square text-success fa-2x pointer" />
        </span>
    </div>
</template>
<script>
export default {
    name: "RevieveSampleCheckbox",
    props: {
        row: {
            default: () => null,
        },
        rowDetails: {
            default: () => [],
        },
    },
    computed: {
        hasSample() {
            return !!this.rowDetails.find(e => e === this.row);
        }
    },
    methods: {
        addSample() {
            this.$emit('addingSample', this.row);
        },
        deleteSample() {
            this.$emit('removingSample', this.rowDetails.indexOf(this.row));
        },
    }
}
</script>